/**
 * Created by Макс on 01.11.2017.
 */
import { Component, ElementRef } from '@angular/core';
import { Broadcaster } from '../service/Broadcaster';
import { SingService } from '../service/sing.service';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
    selector: 'dealer-edit-products-comp',
    templateUrl: 'edit-products/index.html',
    styleUrls: ['add-access/bootstrap.min.css','add-access/update.css','add-access/style.css'], //left-menu/style.min.css
})
export class DealerEditProductsComponent {
    FligthDate: any = ['03/02 - 11/02', '12/02 - 22/02', '23/02 - 30/02'];
    constructor(
        private broadcaster: Broadcaster,
        private elRef: ElementRef,
        private httpService: SingService,
        private route: ActivatedRoute,
        private router: Router,
    ) { }

    ngOnInit() { }
}



// WEBPACK FOOTER //
// ./src/app/components/dealer/dealer-edit-products.component.ts